// 双随机检查管理
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/daily/wuyeDailyCheck/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/daily/wuyeDailyCheck/startFlow',
        method: 'post',
        data: params
    })
}